import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/assets/animate.css';
import '@/assets/iconfont/iconfont.css';
import http from '@/api/http'
import loading from '@/components/loading'
import noData from '@/components/no-data'
import image from "@/components/image"
import {mapGetters} from 'vuex'


Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.component('loading', loading);
Vue.component('no-data', noData);
Vue.component('i-image', image);

new Vue({
    router,
    store,
    render: h => h(App),
    methods: {
        getHome: function () {
            this.$http.request('home').then(res => {
                if (res.status === 'success') {
                    this.$store.commit('setBaseConfig', res.data);
                    document.title = res.data.website_title;
                }
            });
        },
        isMobile: function () {
            let ua = navigator.userAgent;
            let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
                isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
                isAndroid = ua.match(/(Android)\s+([\d.]+)/),
                isMobile = isIphone || isAndroid;
            if (isMobile && window.location.href.indexOf('mobile.html') === -1) {
                window.location.href = "/mobile.html";
            }
        }
    },
    mounted: function () {
        document.title = '';
        this.getHome();
    },
    created: function () {
       // this.isMobile();
    }
}).$mount('#app')
